// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".secondary-nav-menu[data-v-3d6ac887]{margin-bottom:10px;max-width:-moz-fit-content;max-width:fit-content;margin-left:auto;margin-right:auto}@media(min-width:992px){.secondary-nav-menu[data-v-3d6ac887]{max-width:unset}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
